function productsAddOns() {
  const showMoreButtons = document.querySelectorAll('.view__more-btn');
  const showLessButtons = document.querySelectorAll('.view__less-btn');

  showMoreButtons.forEach(button => {
    button.addEventListener('click', () => {
      const productList = button.closest('.related__product-list');
      const hiddenProducts = productList.querySelectorAll('.related__product-flex--item.hidden');

      hiddenProducts.forEach(function (product) {
        product.classList.remove('hidden'); // Show hidden products
      });

      button.classList.add('hidden'); // Hide "Show More" button
      const correspondingShowLessButton = productList.querySelector('.view__less-btn');
      if (correspondingShowLessButton) {
        correspondingShowLessButton.classList.remove('hidden'); // Show "Show Less" button
      }
    });
  });

  showLessButtons.forEach(button => {
    button.addEventListener('click', () => {
      const productList = button.closest('.related__product-list');
      const visibleProducts = productList.querySelectorAll('.related__product-flex--item:not(.hidden)');
      const totalProducts = productList.querySelectorAll('.related__product-flex--item');

      // Hide all products except the first few
      visibleProducts.forEach((product, index) => {
        if (index >= 2) { // Assuming you want to show 2 initially
          product.classList.add('hidden'); // Hide additional products
        }
      });

      button.classList.add('hidden'); // Hide "Show Less" button
      const correspondingShowMoreButton = productList.querySelector('.view__more-btn');
      if (correspondingShowMoreButton) {
        correspondingShowMoreButton.classList.remove('hidden'); // Show "Show More" button
      }
    });
  });
}
function addOnsCartAjax() {
  const switchers = document.querySelectorAll('.related-item__switcher');
  switchers.forEach(switcher => {
    switcher.addEventListener('click', function () {
      const variantId = this.value;
      const isChecked = this.getAttribute('aria-checked') === 'true';

      const newState = !isChecked;
      this.setAttribute('aria-checked', newState);
      this.setAttribute('data-state', newState ? 'checked' : 'unchecked');
      this.querySelector('span').setAttribute('data-state', newState ? 'checked' : 'unchecked');

      if (newState) {
        addToCart(variantId);
      } else {
        removeFromCart(variantId);
      }
    });
  });

  function addToCart(variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Added to cart:', data);
    })
    .catch((error) => {
      console.error('Error adding to cart:', error);
    });
  }

  function removeFromCart(variantId) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({
        updates: {
          [variantId]: 0
        }
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Removed from cart:', data);
    })
    .catch((error) => {
      console.error('Error removing from cart:', error);
    });
  }
}
document.addEventListener('DOMContentLoaded', function () {
  productsAddOns();
  addOnsCartAjax();
});